// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2BLCd","textarea":"styles_textarea__FjT-J","helperText":"styles_helperText__2eLsq","textareaLength":"styles_textareaLength__3h23i"};